import Component from "../../classes/Component";
import {$events} from "../../helpers/events";
import {$dom} from "../../helpers/dom";

const {get, getAll} = $dom

const labelCountSelector = '.js-cart-control-label-count'
const labelPriceSelector = '.js-cart-control-label-price'
const labelSelector = '.js-cart-control-label'
const labelButtonSelector = '.js-cart-control-label-button'
const coastSelector = '.js-cart-coast'

export default function () {
    let label = 1

    const handleRecount = (e) => {
        const labelCount = getAll(labelCountSelector)
        const labelPrice = getAll(labelPriceSelector)
        const coast = get(coastSelector).dataset['coast']
        const action = e.target.dataset['action']

        if (action === 'plus') {
            label += 1
        } else if (action === 'minus') {
            label -= 1
        } else {
            label = 1
        }

        labelPrice.forEach(item => {
            item.innerHTML = (Number(coast) * label).toString() + ' ₽'
        })

        labelCount.forEach(item => {
            item.innerHTML = `В корзине ${label} шт`
        })
    }

    return new Component({
        name: 'labelCount',
        requiredTargets: [labelCountSelector, labelPriceSelector, labelSelector, labelButtonSelector, coastSelector],
        onInit() {
            $events.delegate.on('click', labelButtonSelector, handleRecount)
        },
        onDestroy() {
            console.log('labelCount')
        },
    })

}